//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
import { Tooltip } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Box } from "@mui/system";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Body, Title, Typography } from "@vds/typography";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as Info } from "../../assets/info.svg";
import "./cameraInfo.css";
import {
  fetchDiscoveredCamerasEndPointByCompanion,
  unpairCameraEndPoint,
} from "../../configuration";
import { useNavigate } from "react-router-dom";

import CreateWidgetWithComponent from "../../global/CreateWidgetWithComponent";
import axiosInstance from "../../global/axiosInterceptor";
import EditDevice from "../../global/components/Devices/EditDevice";
import { DEVICE_LIST_TYPE } from "../../global/constants/devices";
import GmtToLocal from "../../global/utility/GmtToLocal";
import {
  Base64ImageDecoder,
  getResourceIdentifierForDevice,
} from "../../global/utility/Utils";
import { hasPermission } from "../../global/utility/permissionUtils";
import { Spinner } from "react-bootstrap";
import { Notification } from "@vds/notifications";
import { deleteItem } from "../../api/SessionServiceManager";
import { Loader } from "@vds/loaders";
import FloorImageHoc from "../../hoc/FloorImageHoc";
import { ComponentTypes } from "../../model/ComponentTypes";
import {
  getAllCameraAndFovsDevices,
  fetchIncidentsByFloorRequest,
  modalOpen,
  refreshCameraPage,
  removeCameraFromList,
  setShowSensorActivateModal,
  showNotificationBanner,
  showCalibrationBanner,
  updateCameraOnboaredDetails,
  updateDeviceFovList,
  updateDevices,
  updateCameraCalibrationStatus
} from "../../store/actions";
import { getDeviceMatchingRecordsList } from "../../global/utility/Utils";
import { fetchAllCameraAndFovsForRbac } from "../../api/DeviceServiceManager";
import CameraInfoText from "./commonComponents/cameraInfoText";
import LiveFeed from "./commonComponents/liveFeed";
import DiscoverCamera from "../../features/camerOnboarding/discoveredCameraOnboarding";
import CameraStreamList from "./commonComponents/cameraStreamList";
import CameraEvents from "./commonComponents/cameraEvents";
import ErrorTemplate from "../../global/components/errorTemplate/ErrorTemplate";
import { TEXT } from "../../global/constants/errorTemplateConstants";
import { checkStreamCalibration } from "../../global/utility/Utils";
import { NOTIFICATION_TYPES, TITLES, SUBTITLES, BUTTON_LABELS } from "../../constants/cameraInfoConstants";
import store from "../../store";
import { useWindowSize } from "../../global/hooks/viewportHooks";
import { breakpoints } from "../../styles/breakpoints";
import { LICENSE_VALUES, LICENSE_TYPES } from "../../global/constants/licensesConstants";
import { ROUTES } from "../../global/constants/routesConstants";

//import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";

const CameraInfo = () => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const { cameraUpdateStatus, cameraCalibrationStatus } = useSelector((state) => state.deviceReducer);
  const companionReducerList = useSelector(
    (state) => state?.deviceReducer?.companionDeviceList
  );
  const refreshPage = useSelector(
    (state) => state.deviceReducer.refreshCameraStatus
  );
  const notificationBannerState = useSelector((state) => state.notificationBanner);
  const calibrationBannerState = useSelector((state) => state.calibrationBanner);
  const fovList = useSelector((state) => state.deviceReducer?.fovList);
  const dispatch = useDispatch();
  const [camDetails, setcamDetails] = useState([]);
  const [showEditDevice, setShowEditDevice] = useState(false);
  const [displayListType, setDisplayListType] = useState(0);
  const [evidences, setEvidences] = useState([]);
  const [loader, setLoader] = useState(false);

  const [deviceTagsList, setDeviceTagsList] = useState([]);

  const [channelInfo, updateChannelInfo] = useState({ name: "" });
  const [isLiveChannelEdit, setIsLiveChannelEdit] = useState(false);

  const [deviceInfo, setdeviceInfo] = useState([]);

  const [floorImage, setFloorImage] = useState();

  const [isManualAdded, setIsManualAdded] = useState(false);
  const [companions, setCompanions] = useState([]);
  const [fovData, setFovData] = useState([]);

  const [siteName, setSiteName] = useState("");
  const [floorTitle, setFloorTitle] = useState("");
  const [liveFeedPermitted, setLiveFeedPermitted] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [liveFeedList, setLiveFeedList] = useState([]);
  const [savedSubscribedCvApps, setSavedSubscribedCvApps] = useState({ names: undefined });
  const [isDeleteCameraLoading, setIsDeleteCameraLoading] = useState(false);
  const [cameraError, setCameraError] = useState(false);
  const [unresolvedEventData, setUnresolvedEventData] = useState(null);

  const { width } = useWindowSize();
  const buttonSize = width <= parseInt(breakpoints.tablet) - 1 ? "small" : "large";

  let navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  const [cameraId, setcameraId] = useState();
  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };

  useEffect(() => {
    const id = getQueryParam("cameraId");
    if (!id) {
      navigate("/devices");
    }
    if (id) {
      setLoader(true);
      fetchMyAPI(id);
      setcameraId(id);
    }
  }, [location]);
  useEffect(() => {
    if (showEditDevice === false) {
      updateChannelInfo({ name: "" });
      setIsLiveChannelEdit(false);
      setdeviceInfo(camDetails);
    }
  }, [showEditDevice]);

  useEffect(() => {
    thumbnailItems();
  }, [evidences]);

  useEffect(() => {
    if (cameraUpdateStatus && Object.keys(cameraUpdateStatus).length) {
      const notificationInfo = {
        type: "Updated credentials",
        priority: "success",
        data: {
          title: "Updated credentials",
          subTitle: `Updated credentials and Rtsp url successfully!`,
        },
        showNotification: true,
      };
      dispatch(showNotificationBanner(notificationInfo));
      dispatch(updateCameraOnboaredDetails({}));
      fetchMyAPI(cameraId);
    }
  }, [cameraUpdateStatus]);

  useEffect(() => {
    if (!cameraId) return;
    const bannerInfo = calibrationBannerState?.bannerInfo;
    if (
      bannerInfo?.showNotification &&
      bannerInfo?.type === NOTIFICATION_TYPES.STREAM_CALIBRATION &&
      fovList &&
      fovList.length > 0 &&
      !checkStreamCalibration(bannerInfo?.deviceId || cameraId, fovList)
    ) {
      const calibratedStreamName = fovList?.find(f => f.parentdeviceid === (bannerInfo?.deviceId || cameraId))?.name;
      dispatch(showCalibrationBanner({ showNotification: false, type: "", priority: "", isDismissible: true }));
      dispatch(showCalibrationBanner({
        showNotification: true,
        type: "Success",
        priority: "success",
        title: calibratedStreamName ? `${calibratedStreamName} ${TITLES.STREAM_CALIBRATION_COMPLETE}` : TITLES.STREAM_CALIBRATION_COMPLETE,
        subtitle: SUBTITLES.STREAM_CALIBRATION_COMPLETE,
        isDismissible: true,
      }));
    }
  }, [cameraId, calibrationBannerState, fovList, dispatch]);

  useEffect(() => {
    if (!cameraId) return;
    if (refreshPage) {
      setLoader(true);
      fetchMyAPI(cameraId).then((freshFovData) => {
        if (cameraCalibrationStatus) {
          const streamName = freshFovData?.[0]?.name;
          const notificationInfo = {
            type: NOTIFICATION_TYPES.STREAM_CALIBRATION,
            priority: NOTIFICATION_TYPES.WARNING,
            data: {
              title: streamName ? `${streamName} ${TITLES.STREAM_CALIBRATION}` : TITLES.STREAM_CALIBRATION,
              subtitle: SUBTITLES.STREAM_CALIBRATION,
              buttonLabel: BUTTON_LABELS.REFRESH,
            },
            isDismissible: false,
            hideCloseButton: false,
            dispatchAction: getAllCameraAndFovsDevices(),
            cameraInfoDispatchAction: refreshCameraPage(true),
            deviceId: cameraId,
            showNotification: true,
          };
          dispatch(showCalibrationBanner(notificationInfo));
          dispatch(updateCameraCalibrationStatus(false));
        }
        dispatch(refreshCameraPage(false));
      }).catch((error) => {
        console.error(error);
        setLoader(false);
        dispatch(refreshCameraPage(false));
      });
    }
  }, [refreshPage]);

  // useEffect(()=>{
  //   //console.log(camDetails, "camDetails >>>")
  // },[camDetails]);
  const fetchMyAPI = async (id = "") => {
    const deviceList = await fetchAllCameraAndFovsForRbac(
      //cameraId? cameraId : id,
      "",
      activeSession
      // dispatch,
      // updateDeviceFovList
    );
    setLoader(false);
    if (deviceList) {
      const fovlisTiem = deviceList.fovs.filter((f) => {
        return f.kind == "ts.device.onvif.fov";
      });
      dispatch(updateDeviceFovList(fovlisTiem));
      const matchingChildren = deviceList.fovs.filter(
        (item) =>
          item.parentdeviceid === id && item.kind === "ts.device.onvif.fov"
      );
      setLiveFeedList(matchingChildren);
      setFovData(matchingChildren);
      const [filteredCamera] = deviceList.cameras.filter(
        (item) => item.kind === "ts.device.onvif" && item.id === id
      );
      if (!filteredCamera) {
        return setCameraError(true);
      }

      setcamDetails(filteredCamera);
      setdeviceInfo(filteredCamera);
      setDisplayListType(filteredCamera);
      setIsManualAdded(
        filteredCamera?.fovs &&
          filteredCamera?.fovs[0].customdata?.mode === "manual"
          ? true
          : false
      );
      const commonProperties = filteredCamera?.customdata?.location;
      const subArea =
        commonProperties?.subarea?.name === "NA"
          ? ""
          : commonProperties?.subarea?.name + ",";
      const area = commonProperties?.area?.name;
      const floorName = commonProperties?.floor?.name;
      const siteName = commonProperties?.site?.name;
      const floorTitle = subArea + area + "," + floorName;
      setSiteName(siteName);
      setFloorTitle(floorTitle);
      return matchingChildren;
    }
  };

  const thumbnailItems = async () => {
    const itemsList = [];
    if (evidences.length > 0) {
      await Promise.all(
        evidences.map(async (e) => {
          await Promise.all(
            e.evidences.map(async (f) => {
              const { createdAt, id, mediaType, thumbnail } = f;
              const date = GmtToLocal(e.createdAt);
              if (mediaType === "video") {
                const i = {
                  title: date,
                  cardTitle: e.description,
                  evidenceDetail: f,
                  id: id,
                  media: {
                    type: "IMAGE",
                    source: {
                      url: Base64ImageDecoder(thumbnail),
                    },
                  },
                };

                itemsList.push(i);
              }
            })
          );
        })
      );
      // setItems([...itemsList]);
    }
  };

  const editButtonOnClick = (show, name, location) => {
    if (name != "") camDetails.name = name;
    if (location != "") updateCustomData(location);
    setShowEditDevice(show);
    setdeviceInfo(camDetails);
  };

  useEffect(() => {
    setDeviceTagsList(camDetails?.tagids || []);

    const siteId = camDetails?.siteids?.[0];
    if (siteId) {
      dispatch(fetchIncidentsByFloorRequest(siteId));
    }
  }, [camDetails]);

  useEffect(() => {
    if (displayListType === DEVICE_LIST_TYPE.CAMERA) {
      dispatch(setShowSensorActivateModal({ showSensorActivatedModal: false }));
      loadDiscoveredCameraData();
      // loadDeviceListTableData();
    }
  }, [displayListType]);

  const loadDiscoveredCameraData = async () => {
    try {
      const deviceList = JSON.parse(
        sessionStorage.getItem("companionDevicesList")
      );

      // setDiscoveryCameraLoading(true);
      const tableData = [];
      if (deviceList?.length) {
        await Promise.all(
          deviceList?.map(async (item) => {
            const resourceidentifier = getResourceIdentifierForDevice(item);

            //console.log("resourceidentifier", resourceidentifier);

            const response = await axiosInstance.post(
              fetchDiscoveredCamerasEndPointByCompanion(),
              {
                accountname: activeSession.accountId,
                resourceidentifier: resourceidentifier,
                forcediscovery: true,
              }
            );

            const resData = response.data;
            const status = response.status;

            if (resData?.length) {
              const filterResult = resData?.filter((res) => {
                return (
                  tableData?.findIndex((disc) => disc?.refid === res?.refid) < 0
                );
              });
              tableData.push(...filterResult);
            }
          })
        );
        // setDiscoverCameraData(tableData);
        // setDiscoveryCameraLoading(false);
      }
    } catch (e) {
      console.log(e);
      //setDiscoveryCameraLoading(false);
    }
  };

  //   const loadDeviceListTableData = async () => {
  //    // setTableRow([]);
  //     try {
  //       await refreshAllDeviceList(activeSession);
  //      // setRefreshDeviceTable(true);
  //     } catch (err) {
  //       setTableLoading(false);
  //     }
  //   };

  const updateCustomData = (location) => {
    if (camDetails.hasOwnProperty("customdata")) {
      camDetails.customdata.location = location;
    } else {
      var obj = {};
      obj["customdata"] = { location: location };
      camDetails = Object.assign(camDetails, obj);
    }
  };

  let fieldTestArr = camDetails
    ? camDetails.fields
      ? Object.keys(camDetails.fields)
      : null
    : null;
  let newFieldArr = getFieldArr(fieldTestArr);

  function getFieldArr(fields) {
    let initFieldArr = [];
    if (fields) {
      fields.map((field) => {
        if (
          field !== "OUT1" &&
          field !== "OUT2" &&
          field !== "DeviceStatus" &&
          field !== "SNRLastUplink"
        ) {
          initFieldArr.push(field);
        }
      });
    } else {
      return "No properties found";
    }

    return initFieldArr;
  }

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const handleEditCameraClick = () => {
    // const camDetails = state ? state.data : "";
    if (!hasPermission("Cameras", "Edit")) {
      showPermissionsBanner();
    } else {
      dispatch(
        modalOpen({
          isPairing: false,
          camDetails: camDetails,
          onBoradType: isManualAdded ? "Manual" : "Auto",
          editFlow: true,
        })
      );
    }
  };

  const handleDeleteCameraClick = () => {
    if (!hasPermission("Cameras", "Delete")) {
      showPermissionsBanner();
    } else {
      // Reset to undefined so the modal displays the Spinner/Loader 
      // while CameraInfoTable fetches per-stream CV apps
      setSavedSubscribedCvApps({ names: undefined });
      setIsDeleteModalOpen(true);
    }
  };

  useEffect(() => {
    if (hasPermission("Live video feed", "View")) {
      setLiveFeedPermitted(true);
    }
  }, []);

  const CachedFloorImage = FloorImageHoc(
    CreateWidgetWithComponent,
    camDetails?.refid,
    false,
    camDetails?.customdata?.location?.floor?.tag,
    unresolvedEventData
  );

  const handleDeleteCamera = async (cameraItem) => {
    setIsDeleteCameraLoading(true);

    const companion = companionReducerList.find((companion) => companion.id == cameraItem.parentdeviceid);
    let companionidentifier = {};
    companionidentifier[companion.refidtype] = companion?.refid;
    let cameraidentifier = {};
    cameraidentifier[cameraItem.refidtype] = cameraItem?.refid;
    const body = {
      accountname: activeSession.accountId,
      companionidentifier: companionidentifier,
      cameraidentifier: cameraidentifier
    };
    const response = await deleteItem(unpairCameraEndPoint(), body);
    if (response?.status === 200) {
      const notificationInfo = {
        type: "Delete Camera",
        priority: "success",
        data: { subTitle: `Camera unpaired successfully` },
        showNotification: true
      };
      dispatch(removeCameraFromList(cameraItem.id));
      dispatch(showNotificationBanner(notificationInfo));
      if (window.location.pathname === ROUTES.CAMERA_INFO_PAGE) {
        navigate("/devices");
      }
    } else {
      const error = response?.data;
      const message = response?.status === 500 ? `${error?.error_description} ` : "Something went wrong, Please try again later.";
      const notificationInfo = {
        type: "Delete Camera",
        priority: "critical",
        data: { subTitle: `Failed to unpair camera - '${message}' ` },
        showNotification: true
      };
      dispatch(showNotificationBanner(notificationInfo));
      console.error("Failed to unpair camera");
    }

    try {
      fetchAllCameraAndFovsForRbac(activeSession).then(
        (cameraAndFovDevices) => {
          dispatch(
            updateDevices({
              cameraList: cameraAndFovDevices?.cameras,
              fovList: cameraAndFovDevices?.fovs,
            })
          );
        }
      );
    } catch (error) {
      console.log("Failed to fetch camera and FOV devices");
    }

    setIsDeleteCameraLoading(false);
    handleCloseModal();
  };
  const handleCloseModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleFetchSubscribedCvAppsError = () => {
    const notificationInfo = {
      type: "Delete Camera",
      priority: "critical",
      data: { subTitle: "Failed to check subscribed apps for this camera. Please try again." },
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
    handleCloseModal();
  };

  if (cameraError) {
    return (
      <div className="camera-info__error-container">
        <ErrorTemplate title={TEXT.CAMERA_NOT_FOUND_ERROR} description={TEXT.CAMERA_NOT_FOUND_DESC} onRefresh={() => navigate("/devices")} />
      </div>
    );
  }

  return (
    <>
      <DiscoverCamera onClose={() => dispatch(modalOpen({}))} />
      <Breadcrumbs surface="light">
        {state?.originPage === "associatedStreams" ? (
          <>
            <BreadcrumbItem>
              <Link
                data-testid="cameraInfo_enrolledAppearancesLink"
                to="/enrolledappearance"
                className="breadcrums-item_link"
              >
                Enrolled Appearances
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link
                data-testid="cameraInfo_associatedStreamsLink"
                to="/appearanceDeployments"
                state={{ appearance: state?.appearance || {} }}                
                className="breadcrums-item_link"
              >
                {state?.appearance?.name || "Appearance"}
              </Link>
            </BreadcrumbItem>
          </>
        ) : (
          <BreadcrumbItem>
              <Link data-testid="cameraInfo_toDevicesLink" to="/devices" state={{ tabName: "Camera" }} className="breadcrums-item_link">
              Cameras
            </Link>
          </BreadcrumbItem>
        )}
        <BreadcrumbItem>Camera Details</BreadcrumbItem>
      </Breadcrumbs>
      <Modal
        className="camera-info__delete-modal"
        opened={isDeleteModalOpen}
        disableOutsideClick={true}
        hideCloseButton={true}
        closeButton={
          <div
            className="camera-info__modal-close"
            data-testid="newCameraInfo_deleteCameraModalTopCancelButton"
            onClick={() => {
              setIsDeleteModalOpen(false);
            }}
          >
            <Icon name="close" />
          </div>
        }
      >
        {isDeleteCameraLoading ? (
          <div className="camera-info__modal-loader">
            <Spinner />
          </div>
        ) : (
          <>
            <ModalTitle>
              <div className="camera-info__modal-title-wrapper">
                <Title size="large" use="primary" viewport="desktop" bold={true}>
                  Delete Camera
                </Title>
              </div>
              <Notification
                type="warning"
                hideCloseButton={false}
                title="Warning"
                subtitle="If a camera is deleted, all configurations associated with computer vision apps will be deleted and the camera will no longer be subscribed to any CV licenses or CV Apps. Therefore the camera will no longer generate events, alerts, statistics, or video evidence."
              />
            </ModalTitle>
            <ModalBody>
              <Body size="large">
                {savedSubscribedCvApps?.names === undefined ? (
                    <Loader active={true} fullscreen={false} />
                ) : (
                  <>
                    {savedSubscribedCvApps?.names?.length > 0 ? (
                      <>
                        <p>You must unsubscribe to all apps running on this camera in order to delete.</p>
                        <b>Apps</b>
                        <ul>
                          {savedSubscribedCvApps?.names?.map((item, idx) => (
                            <li key={idx} className="camera-info__modal-delete-app-item">{item}</li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <p>Are you sure you’d like to delete this camera?</p>
                    )}
                  </>
                )}
              </Body>
              <div className="camera-info__modal-actions">
                <Button
                  size="large"
                  disabled={
                    isDeleteCameraLoading ||
                    savedSubscribedCvApps?.names === undefined ||
                    savedSubscribedCvApps?.names?.length > 0
                  }
                  width="100%"
                  use="primary"
                  data-testid="newCameraInfo_deletePrimaryCameraButton"
                  onClick={() => handleDeleteCamera(camDetails)}
                >
                  {isDeleteCameraLoading ? "deleting..." : "Yes, delete"}
                </Button>
                <Button
                  size="large"
                  disabled={false}
                  width="100%"
                  use="secondary"
                  data-testid="newCameraInfo_deleteSecondaryCameraButton"
                  onClick={() => handleCloseModal()}
                >
                  No, cancel
                </Button>
              </div>
            </ModalBody>
          </>
        )}
      </Modal>

      {!loader && (
        <div className="sasp_vz-nhg-eds-font camera-info__header">
          <div className="camera-info__name-container">
            <div className="camera-info__name-row">
              <div className="camera-info__name">{deviceInfo?.name}</div>
              <Tooltip
                placement="top"
                title={
                  <div className="camera-info__tooltip-content">
                    <Body viewport="desktop" size="small" bold={true}>
                      {" "}
                      Camera Id{" "}
                    </Body>
                    <Body size="small" viewport="desktop">
                      {deviceInfo?.id}
                    </Body>
                  </div>
                }
                arrow
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "white",
                      border: "1px solid black",
                      "& .MuiTooltip-arrow": {
                        backgroundColor: "white"
                      }
                    }
                  }
                }}
              >
                <sup>
                  {" "}
                  <Info />{" "}
                </sup>
              </Tooltip>
            </div>
            <CameraInfoText fovData={fovData} cameraDetails={camDetails} isManualAdded={isManualAdded} setCompanions={setCompanions} />
          </div>

          <div className="camera-info__buttons">
            <Button size={buttonSize} disabled={false} use="primary" data-testid="cameraInfo_editButton" onClick={handleEditCameraClick}>
              Edit
            </Button>
            <Button size={buttonSize} disabled={false} use="secondary" data-testid="cameraInfo_deleteButton" onClick={handleDeleteCameraClick}>
              Delete
            </Button>
          </div>
        </div>
      )}

      <Modal
        className="camera-info__edit-modal"
        opened={showEditDevice}
        disableOutsideClick={true}
        hideCloseButton={true}
        closeButton={
          <div
            className="camera-info__modal-close"
            data-testid="cameraInfo_closeIconButton"
            onClick={() => {
              setShowEditDevice(false);
            }}
          >
            <Icon name="close" />
          </div>
        }
      >
        <EditDevice
          deviceInfo={deviceInfo}
          setShowEditDevice={editButtonOnClick}
          deviceTagsList={deviceTagsList}
          setDeviceTagsList={setDeviceTagsList}
          channelInfo={channelInfo}
          isLiveChannelEdit={isLiveChannelEdit}
        />
      </Modal>

      <Grid2
        container
        marginTop={3}
        marginBottom={3}
        spacing={1}
        columns={{ xs: 18 }}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "stretch"
        }}
      >
        <Grid2
          xs={18}
          lg={9}
          direction="row"
          className="camera-info__left-panel"
        >
          {loader && (
            <Box sx={{ height: "500px" }}>
              {" "}
              <Loader active={loader} fullscreen={false} />{" "}
            </Box>
          )}
          {!loader && liveFeedPermitted && <LiveFeed liveFeedList={liveFeedList} />}
          {!loader && !liveFeedPermitted && (
            <div className="camera-info__no-feed-box">
              <div>
                <Typography className="camera-info__no-feed-heading">
                  Live feed is not available.
                </Typography>
                <Typography className="camera-info__no-feed-body">
                  You do not have the required access to watch live feed. Please view your permissions on the users page or talk to your system administrator.
                </Typography>
              </div>
            </div>
          )}
        </Grid2>

        <Grid2
          xs={18}
          lg={9}
          direction="row"
          className="device_grid_2 camera-info__right-panel"
        >
          {loader && (
            <Box sx={{ height: "500px" }}>
              {" "}
              <Loader active={loader} fullscreen={false} />{" "}
            </Box>
          )}
          {!loader && (
            <div className="camera-info__floor-card">
              <span className="camera-info__floor-title">{floorTitle}</span>
              <br />
              <span>{siteName}</span>
              <div className="camera-info__floor-image-wrapper">
                <CachedFloorImage title="" inputHeight="100%" comp={ComponentTypes.floorPlan} cameraId={camDetails?.id} />
              </div>
            </div>
          )}
        </Grid2>
      </Grid2>
      {!loader && (
        <>
          {" "}
          <CameraStreamList
            cameraData={camDetails}
            setSavedSubscribedCvApps={setSavedSubscribedCvApps}
            isDeleteModalOpen={isDeleteModalOpen}
            isManualAdded={isManualAdded}
            companions={companions}
            liveFeedList={liveFeedList}
            setLiveFeedList={setLiveFeedList}
            onFetchSubscribedCvAppsError={handleFetchSubscribedCvAppsError}
            // cameraCVAppList={cameraCVAppList}
          />
          <CameraEvents 
            state={camDetails} 
            cameraId={camDetails?.id}
            onUnresolvedEventsChange={setUnresolvedEventData}
          />
        </>
      )}
    </>
  );
};

export default CameraInfo;
